import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatNsuList(numbers: string[], max = 5): string {
  if (numbers.length === 0) return "";
  if (numbers.length <= max) return numbers.join(", ");
  const head = numbers.slice(0, max).join(", ");
  const remaining = numbers.length - max;
  return `${head} e mais ${remaining}`;
}
